import { PaymentRequestItem } from '@stripe/stripe-js'
import accounting from 'accounting'
import { PaymentRequestInfo } from '../model'

export enum DisplayFormatEnum {
  INTEGER = 1,
  DECIMAL = 2,
  PERCENTAGE = 3
}

function numberFormat(
  value: any,
  displayFormat: DisplayFormatEnum,
  displayPrecision: number = 2
): string {
  try {
    if (value === 0) {
      if (displayFormat === DisplayFormatEnum.PERCENTAGE) {
        return '0.00%'
      } else if (displayFormat === DisplayFormatEnum.DECIMAL) {
        return '0.00'
      } else {
        return '0'
      }
    }
    if (!value) {
      return '--'
    }
    if (displayFormat === DisplayFormatEnum.INTEGER) {
      if (value < 0 && value > -0.5) {
        return '0'
      }
      const result: string = accounting.formatNumber(value, 0)
      if (result === '-0') {
        return '0'
      }
      return result
    } else if (displayFormat === DisplayFormatEnum.DECIMAL) {
      if (displayPrecision === 0) {
        return accounting.formatNumber(value, 0)
      } else {
        return accounting.formatNumber(value, displayPrecision || 2)
      }
    } else if (displayFormat === DisplayFormatEnum.PERCENTAGE) {
      return (
        accounting.formatNumber(
          value * 100,
          displayPrecision === null || displayPrecision === undefined
            ? 2
            : displayPrecision
        ) + '%'
      )
    } else {
      return value
    }
  } catch (error) {
    // console.error(error);
    return '--'
  }
}

function toThousands(numinput: string | number): string {
  let num = (numinput || 0).toString()
  let result = ''
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result
    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  return result
}

function isiOS() {
  var u = navigator.userAgent

  //iOS
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  return isiOS
}

function isSafari() {
  var issafariBrowser =
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  return issafariBrowser
}

function isAndroid() {
  var u = navigator.userAgent

  //Android
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

  return isAndroid
}

function isWeChatEnv() {
  var ua = window.navigator.userAgent.toLowerCase()
  var matched0 = ua.match(/MicroMessenger/i)
  var matched1 = ua.match(/_SQ_/i)
  if (
    (matched0 && matched0[0] === 'micromessenger') ||
    (matched1 && matched1[1] === '_sq_')
  ) {
    return true
  } else {
    return false
  }
  // return true;
}

function buildRequestPaymentInfor(paymentRequestInfo: PaymentRequestInfo) {
  let { billTotalDisplayItem, billDetailDisplayItems } = paymentRequestInfo

  return {
    total: billTotalDisplayItem,
    displayItems: [...billDetailDisplayItems].filter((item: any) => {
      return !!item
    }) as PaymentRequestItem[]
  }
}

export {
  toThousands,
  numberFormat,
  isWeChatEnv,
  isAndroid,
  isiOS,
  isSafari,
  buildRequestPaymentInfor
}
